import { render, staticRenderFns } from "./SalesRevenue.vue?vue&type=template&id=488a7642"
import script from "./SalesRevenue.vue?vue&type=script&lang=js"
export * from "./SalesRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports